/**
 * servicing eapi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface GetDocumentListTktRequest {
  /**
   * 検索種別
   */
  searchType: GetDocumentListTktRequest.SearchTypeEnum;
  /**
   * 検索年月（形式：yyyyMM）
   */
  searchYearMonth: string;
  /**
   * 検索日（形式：dd）
   */
  searchDay?: string;
}
export namespace GetDocumentListTktRequest {
  export type SearchTypeEnum = 'eTicketByDepartureDate' | 'eTicketByPurchaseDate';
  export const SearchTypeEnum = {
    ETicketByDepartureDate: 'eTicketByDepartureDate' as SearchTypeEnum,
    ETicketByPurchaseDate: 'eTicketByPurchaseDate' as SearchTypeEnum,
  };
}
